<!--
 * @Description: 列表组件，用于首页、全部商品页面的商品列表
 * @Author: hai-27
 * @Date: 2020-02-07 16:23:00
 * @LastEditors: hai-27
 * @LastEditTime: 2020-04-05 13:22:22
 -->
<template>
  <div id="myList" class="myList">
    <ul>
      <li v-for="item in list" :key="item.product_id">
        <el-popover placement="top">
          <p>{{ $t('common.confirm') }}{{ $t('common.delete') }}?</p>
          <div style="text-align: right; margin: 10px 0 0">
            <el-button type="primary" size="mini" @click="deleteCollect(item.product_id)">{{ $t('common.confirm') }}</el-button>
          </div>
          <i class="el-icon-close delete" slot="reference" v-show="isDelete"></i>
        </el-popover>
        <router-link :to="{ path: '/goods/details', query: {productID:item.product_id} }">
          <img :src="item.product_picture" alt />
          <h2>{{item.product_name}}</h2>
          <h3>{{item.product_title}}</h3>
          <p>
            <span>{{Math.floor(item.product_selling_price)}}₫</span>
            <span
              v-show="item.product_price != item.product_selling_price"
              class="del"
            >{{Math.floor(item.product_price)}}₫</span>
          </p>
        </router-link>
      </li>
      <li v-show="isMore && list.length>=1" id="more">
        <router-link :to="{ path: '/goods', query: {categoryID:categoryID} }">
          {{ $t('goods.viewDetails') }}
          <i class="el-icon-d-arrow-right"></i>
        </router-link>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "MyList",
  // list为父组件传过来的商品列表
  // isMore为是否显示“浏览更多”
  props: ["list", "isMore", "isDelete"],
  data() {
    return {};
  },
  computed: {
    // 通过list获取当前显示的商品的分类ID，用于“浏览更多”链接的参数
    categoryID: function() {
      let categoryID = [];
      if (this.list != "") {
        for (let i = 0; i < this.list.length; i++) {
          const id = this.list[i].category_id;
          if (!categoryID.includes(id)) {
            categoryID.push(id);
          }
        }
      }
      return categoryID;
    }
  },
  methods: {
    deleteCollect(product_id) {
      this.$axios
        .post("/api/user/collect/deleteCollect", {
          user_id: this.$store.getters.getUser.user_id,
          product_id: product_id
        })
        .then(res => {
          switch (res.data.code) {
            case "001":
              // 删除成功
              // 删除删除列表中的该商品信息
              for (let i = 0; i < this.list.length; i++) {
                const temp = this.list[i];
                if (temp.product_id == product_id) {
                  this.list.splice(i, 1);
                }
              }
              // 提示删除成功信息
              this.notifySucceed(this.$t('collect.removeSuccess'));
              break;
            default:
              // 提示删除失败信息
              this.notifyError(res.data.msg);
          }
        })
        .catch(err => {
          return Promise.reject(err);
        });
    }
  }
};
</script>
<style scoped>
.myList {
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
}
.myList ul {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
  box-sizing: border-box;
}
.myList ul li {
  z-index: 1;
  box-sizing: border-box;
  min-width: 0;
  min-height: 280px;
  padding: 18px 12px 20px;
  margin: 0;
  background-color: #fff;
  -webkit-transition: all 0.2s linear;
  transition: all 0.2s linear;
  position: relative;
  text-align: center;
}
.myList ul li a {
  display: block;
  text-align: center;
  color: inherit;
  text-decoration: none;
}
.myList ul li:hover {
  z-index: 2;
  -webkit-box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  -webkit-transform: translate3d(0, -2px, 0);
  transform: translate3d(0, -2px, 0);
}
.myList ul li img {
  display: block;
  width: 160px;
  height: 160px;
  max-width: 100%;
  object-fit: contain;
  background: url(../assets/imgs/placeholder.png) no-repeat 50%;
  margin: 0 auto;
}
.myList ul li h2 {
  margin: 16px 8px 0;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.myList ul li h3 {
  margin: 6px 8px 0;
  min-height: 18px;
  font-size: 12px;
  font-weight: 400;
  color: #b0b0b0;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.myList ul li p {
  margin: 10px 8px 0;
  text-align: center;
  color: #ff6700;
  font-size: 14px;
}
.myList ul li p .del {
  margin-left: 0.5em;
  font-size: 12px;
  color: #b0b0b0;
  text-decoration: line-through;
}
.myList #more {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 280px;
  padding: 0;
}
.myList #more a {
  font-size: 18px;
  color: #333;
  line-height: 1.4;
}
.myList #more a:hover {
  color: #ff6700;
}
.myList ul li .delete {
  position: absolute;
  top: 10px;
  right: 10px;
  display: none;
}
.myList ul li:hover .delete {
  display: block
}
.myList ul li .delete:hover {
  color: #ff6700;
}

/* 移动端响应式样式 */
@media (max-width: 768px) {
  .myList ul {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 8px;
  }
  .myList ul li {
    min-height: auto;
    padding: 8px 6px 12px;
  }
  .myList ul li img {
    width: 100%;
    max-width: 100%;
    height: auto;
    aspect-ratio: 1;
  }
  .myList ul li h2 {
    font-size: 11px;
    margin: 8px 2px 0;
    white-space: normal;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .myList ul li h3 {
    font-size: 10px;
    margin: 4px 2px 0;
    white-space: normal;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    min-height: 0;
  }
  .myList ul li p {
    font-size: 11px;
    margin: 6px 2px 0;
    word-break: break-all;
  }
  .myList #more {
    min-height: auto;
    padding: 12px 8px;
  }
  .myList #more a {
    font-size: 11px;
    line-height: 1.3;
    word-break: break-word;
  }
}
</style>